import React from 'react';
import { createRoot } from 'react-dom/client'; // Step 1
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const container = document.getElementById('root'); // Reference to your app's root element
const root = createRoot(container); // Step 2: Create a root.

root.render( // Step 3: Use the root to render your app.
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
